import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

export const getInboxChatResources = async websiteToken => {
  const urlData = endPoints.getInboxChatResources(websiteToken);
  return API.get(urlData.url, { params: urlData.params });
};
